import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatusState } from "../types";

interface LoginInfo {
    token: string;
    userID: number;
    firebaseToken: string;
}

export const statusInitialState: StatusState = {
    showLoginDialog: false,
    token: '',
    userID: -1,
    firebaseToken: '',
};

const initialState = statusInitialState;

export const statusReducer = createSlice({
    name: 'status',
    initialState,
    reducers: {
        setShowLoginDialog: (state, action: PayloadAction<boolean>) => {
            state.showLoginDialog = action.payload;
        },
        setLoginInfo: (state, action: PayloadAction<LoginInfo>) => {
            state.token = action.payload.token;
            state.userID = action.payload.userID;
            state.firebaseToken = action.payload.firebaseToken;
        }
    }
});

export const { setShowLoginDialog, setLoginInfo } = statusReducer.actions;

export default statusReducer.reducer; 